<template>
    <div id="filter_general"
        :style="style.width < 500 ? {textAlign: 'right'} : {}">

        <div class="ui action input" v-if="!filter.is_advanced_mode">
            <HeaderInputs
                v-if="style.width >= 500"
            >
            </HeaderInputs>

            <!--
            * ========================================================================
            * = quick keys dropdown
            * ========================================================================
            -->
            <div class="ui selection dropdown no_search right_radius"
                style="min-width:120px;"
                v-dropdown>
                <div class="text"
                    v-for="item in filter.shortcut_keys"
                    v-if="filter.current_shortcut_key == item">
                    <span v-if="item == 'customer_note'">
                        {{ $t('models.attributes.operations.your_note') }}
                    </span>
                    <span v-else-if="item == 'created_duration'">
                        {{ $t('models.attributes.operations.created_at') }}
                    </span>
                    <span v-else>
                        {{ $t('models.attributes.operations.'+item) }}
                    </span>
                </div>
                <i class="dropdown icon"></i>
                <div class="menu">
                    <div class="item"
                        v-for="item in filter.shortcut_keys"
                        :class="{'selected active': filter.current_shortcut_key == item }"
                        @click="set_quick_filter(item)"
                        >
                        <span v-if="item == 'customer_note'">
                            {{ $t('models.attributes.operations.your_note') }}
                        </span>
                        <span v-else-if="item == 'created_duration'">
                            {{ $t('models.attributes.operations.created_at') }}
                        </span>
                        <span v-else>
                            {{ $t('models.attributes.operations.'+item) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="ui button icon" @click="$parent.$parent.operations_filter()">
                <i class="search icon"></i>
            </div>
        </div>

        <!-- advanced 才顯示 -->
        <div class="ui basic red icon button"
            v-if="filter.is_advanced_mode"
            @click="$store.commit('customer/operations_module/init_filter_columns')">
            <i class="close icon"></i>
            {{ $t('ui.general.clear') }}
        </div>

        <div class="ui button icon"
            @click="filter.is_advanced_mode = !filter.is_advanced_mode"
            :style="{
                height: (!filter.is_advanced_mode) ? '38px' : 'auto',
                paddingTop: (!filter.is_advanced_mode) ? '13px' : '',
                verticalAlign: (!filter.is_advanced_mode) ? 'top' : '',
                margin: '0 6px',
            }
            ">
            <i class="bars icon"
                :class="{
                    minus: filter.is_advanced_mode,
                    bars: !filter.is_advanced_mode,
                }"
            ></i>

        </div>
        <div class="ui action input"
            v-if="!filter.is_advanced_mode &&
                style.width < 500 &&
                filter.current_shortcut_key != 'is_done'"
            style="padding-top: 9px; width:100%">
            <HeaderInputs>
            </HeaderInputs>
        </div>

    </div>
</template>

<script>
import HeaderInputs from './header_inputs.vue'

export default {
    name: "OperationsFilterHeader",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.customer.operations_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        set_quick_filter(item = null) {
            try {
                this.filter.current_shortcut_key = item
                this.filter.columns.created_duration = ""
                _.forEach(this.filter.shortcut_keys, value => {
                    this.filter.columns[value] = null
                })

                if (item == 'is_done') {
                    this.filter.columns.is_done = true
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    components: {
        HeaderInputs
    }
}
</script>

<style scoped lang="scss">
    .right_radius, .right_radius input {
        border-bottom-right-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }
</style>
